<template>
    <div
        v-if="item.children && item.children.length > 0"
        @mouseover="isHovering = true"
        @mouseleave="isHovering = false"
        class="sub-menu-item"
    >
        <typo name="menu-14-normal">
            {{ item.shortTitle ? item.shortTitle : item.title }}
        </typo>

        <transition name="mag-sub-menu-items-transition">
            <mag-submenu-item-groups :item="item" class="mag-submenu-item" v-if="isHovering" />
        </transition>
    </div>
    <router-link v-else :to="`/espace-client/mag?category=${item.name}`" class="sub-menu-item">
        <typo name="menu-14-normal">
            {{ item.shortTitle ? item.shortTitle : item.title }}
        </typo>
    </router-link>
</template>

<script>
import Vue from "vue";
import MagSubmenuItemGroups from "./MagSubmenuItemGroups.vue";
export default Vue.extend({
    components: { MagSubmenuItemGroups },
    props: ["item"],
    data() {
        return {
            isHovering: false,
        };
    },
});
</script>

<style lang="sass" scoped>
.sub-menu-item
    position: relative
    height: 100%
    display: flex
    align-items: center
    padding-left: 20px
    padding-right: 20px
    color: $color-secondary
    transition: background .15s ease, color .15s ease
    cursor: pointer
    &:hover
        background: $color-secondary
        color: white
.mag-submenu-item
    position: absolute
    width: 400px
    left: 0
    right: 0
    background: #fff
    top: 59px
    z-index: 9
    box-sizing: border-box

.mag-sub-menu-items-transition
    &-enter-active, &-leave, &-leave-to
        transition: transform .15s ease-in, opacity .15s ease-in

    &-enter, &-leave-to
        opacity: 0
        transform: translate(0, -5px)
</style>
